import React, { ReactChild } from 'react';
import { Container } from './MenuSubMenu.styles';

type Props = {
  children: ReactChild;
  className?: string;
};

const MenuSubMenu = (props: Props) => <Container className={props.className}>{props.children}</Container>;
export default MenuSubMenu;
